import { theme, Typography } from 'antd';
import styled from 'styled-components';

// Tier 2 (shared): antd's Typography.Text has no size prop, so a smaller or larger
// line of text would otherwise need an inline `fontSize`. Catalogue: "text size".
const SIZE_TOKEN = {
	xxs: 'fontSizeXXS',
	xs: 'fontSizeXS',
	sm: 'fontSizeSM',
	md: 'fontSize',
	lg: 'fontSizeLG',
};

const StyledText = styled(Typography.Text)`
	&& {
		font-size: ${({ $fontSize }) => $fontSize}px;
	}
`;

/**
 * Typography.Text at a theme-defined size. Every other prop (`strong`, `type`,
 * `ellipsis`, `copyable`, …) goes straight through to antd.
 *
 * Reads the size from `theme.useToken()`, so it needs no provider beyond antd's own.
 *
 * @param {object} props
 * @param {'xxs'|'xs'|'sm'|'md'|'lg'} [props.size] - `fontSizeXXS` and `fontSizeXS` are custom theme
 *   keys; the rest are antd's `fontSizeSM`, `fontSize`, `fontSizeLG`
 */
const BaseText = ({ size = 'md', ...rest }) => {
	const { token } = theme.useToken();

	// A bad size must not crash the subtree: warn in dev and render at the base size.
	if (!SIZE_TOKEN[size] && import.meta.env.DEV)
		console.warn(`BaseText: unknown size "${size}" — use xxs, xs, sm, md or lg`);

	return <StyledText $fontSize={token[SIZE_TOKEN[size] ?? SIZE_TOKEN.md]} {...rest} />;
};

export default BaseText;
